import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongDetailsTitleBar.module.scss";
import {useSongDetailsTitleBarLogic} from "./SongDetailsTitleBar.logic";
import BackButton from "../../../../../../components/common/BackButton";


export const SongDetailsTitleBar: VoidFunctionComponent = () => {
  const {imageUrl, name, artistName, genre, backButtonLabel} = useSongDetailsTitleBarLogic();
  return (
    <header className={s.titleBar}>
      <BackButton label={backButtonLabel} useClassName={s.backButton} />
      <img className={s.songArt} src={imageUrl} alt={''} />
      <h1>{name}</h1>
      <dl className={s.songMetadata}>
        <div className={s.metadataItem}>
          <dt>Artist</dt>
          <dd>{artistName}</dd>
        </div>
        <div className={s.metadataItem}>
          <dt>Genre</dt>
          <dd>{genre}</dd>
        </div>
      </dl>
    </header>
  );
}

